"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Container = styled_components_1.default.div `
  overflow: hidden;
  margin-top: auto;
  margin-bottom: auto;
  text-overflow: ellipsis;
  &.click: {
    cursor: pointer;
  }
  &.flash {
    animation: pulseTx 0.4s ease-in;
  }
  @keyframes pulseTx {
    0%, 100% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(4px);
    }
    70% {
      transform: translateY(6px);
    }
  }
`;
const styles = (theme, _props, classes) => ({
    label: {
        cursor: 'pointer',
        marginTop: 1,
        '&:hover': {
            background: 'rgba(220,230,235, 0.5)',
            transition: '.5s ease',
            borderRadius: '3px',
            [`& .${classes.iconContainer}`]: {
                opacity: 1,
            },
            '&$readOnly': {
                background: 'none',
                cursor: 'text',
            },
        },
    },
    labelFlex: {
        display: 'flex',
    },
    readOnly: {},
    iconContainer: {
        display: 'flex',
        alignItems: 'center',
        opacity: 0,
    },
    labelTextContainer: {
        display: 'inline-block',
    },
    input: {
        alignSelf: 'center',
    },
    inputForTabFocus: {
        position: 'absolute',
        left: '-999px',
        height: 1,
        width: 1,
    },
    textField: {
        paddingBottom: '0px',
        paddingTop: 0,
        marginTop: 1,
        minHeight: 24,
    },
    container: {},
    containerWhenEditing: {
        width: '100%',
    },
    h1: Object.assign({}, theme.typography.h1),
    h2: Object.assign({}, theme.typography.h2),
    h3: Object.assign({}, theme.typography.h3),
    h4: Object.assign({}, theme.typography.h4),
    h5: Object.assign({}, theme.typography.h5),
    h6: Object.assign({}, theme.typography.h6),
    subtitle1: Object.assign({}, theme.typography.subtitle1),
    body1: Object.assign({}, theme.typography.body1),
    body2: Object.assign({}, theme.typography.body2),
    caption: Object.assign({}, theme.typography.caption),
    button: Object.assign({}, theme.typography.button),
});
exports.default = styles;
